import OtpInput from "react18-input-otp";
import styled from "styled-components";
import { ContentContainerBase } from "../../common/components";
import { TextM, TextMS } from "../../common/text";

export const ContentContainer = styled(ContentContainerBase)`
  align-items: center;
`;

export const Header = styled.div`
  width: 80%;
  height: 10%;
  display: flex;

  flex-direction: column;
  justify-content: center;
  align-items: center;

  gap: 20px;
  padding-top: 30px;
  @media ${({ theme }) => theme.device.tablet} {
    padding-top: 50px;
  }
`;

export const RegisterWrapper = styled.div`
  width: 80%;
  height: 45%;
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 20px;
  @media ${({ theme }) => theme.device.tablet} {
    height: 40%;
  }
`;

export const Input = styled(OtpInput)`
  font-family: "Bold";

  width: 45px;
  height: 50px;
  font-size: 25px;

  @media ${({ theme }) => theme.device.tablet} {
    width: 70px;
    height: 80px;
    font-size: 35px;
  }

  border-bottom: 2px solid black;
  margin-left: 5px;
  margin-top: 50px;
  justify-content: center; // 텍스트 중앙배치

  -webkit-appearance: none; // disable default behavior
  &:focus {
    border-bottom: 2px solid #f44b59;
    outline: none;
  }
`;

export const ResendButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const NextButton = styled.div`
  width: 300px;
  height: 60px;
  background-color: ${({ isValidInput }) =>
    isValidInput ? "#f44b59" : "#eaeaea"};

  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;

  @media ${({ theme }) => theme.device.tablet} {
    width: 450px;
    height: 70px;
  }
`;

export const NextButtonText = styled(TextM)`
  color : ${({ isValidInput }) => (isValidInput ? "#FFF" : "#9F9F9F")}}

`;
